import * as React from "react";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import { getPathnameWithoutId } from "util/URLUtils";
import { Button, MenuItem } from "components/bootstrap";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import useLocation from "routing/useLocation";
import { INTERNAL_DATA_LAKE_TYPE } from "data-lake/Constants";
import { INTERNAL_DATA_LAKE_STORAGE_TYPE } from "data-lake/preview/storage-types/internal/Constants";
const RetrievalArchiveButton = ({
  onClick,
  buttonType = "menu",
  dataLakeType = INTERNAL_DATA_LAKE_TYPE,
  dataLakeStorageType = INTERNAL_DATA_LAKE_STORAGE_TYPE
}) => {
  const { pathname } = useLocation();
  const sendTelemetry = useSendTelemetry();
  const onRetrieval = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.DATALAKE[dataLakeType].DATA_RETRIEVAL_OPENED, {
      app_pathname: getPathnameWithoutId(pathname),
      event_details: {
        data_lake_storage_type: dataLakeStorageType
      }
    });
    onClick();
  };
  const isMenuButton = buttonType === "menu";
  const ItemComponent = isMenuButton ? MenuItem : Button;
  return /* @__PURE__ */ React.createElement(ItemComponent, { onClick: onRetrieval, bsSize: "xsmall" }, "Retrieve logs");
};
export default RetrievalArchiveButton;
